// extracted by mini-css-extract-plugin
export default {"page":"zW-z","cartModal":"AW-z","checkout":"BW-z","placeholder":"CW-z","account":"DW-z"};